import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {AuthenticationButtons} from '../../../authentication/AuthenticationButtons'
import {MobileMenuUserInfo} from '../MobileMenuUserInfo'
import {MobileMenuUserSectionSkeleton} from './Skeleton'

type PropsType = {
  /** Whether the user is authenticated */
  isAuthenticated: boolean
  /** Whether user data is still loading */
  isLoading: boolean
  /** Callback for Login click */
  onLogInClick: () => void
  /** Callback for Signup click */
  onSignUpClick: () => void
  onClickEditAccount: () => void
  /** Whether to hide the sign in / create account section */
  isSignInHidden?: boolean
  /** Slot below the user's name, for the brand's loyalty program values */
  programSlot?: React.ReactNode
  /** Tag under the user's name, for the brand's loyalty programme */
  userTagSlot?: React.ReactNode
}

const UserSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: ${cssTheme.layout.spacing.s600} ${cssTheme.layout.spacing.s500}
    ${cssTheme.layout.spacing.s700};
  flex-shrink: 0;
  &.--is-authenticated {
    padding: ${cssTheme.layout.spacing.s600} ${cssTheme.layout.spacing.s500};
    align-items: stretch;
  }
  &.--is-sign-in-hidden {
    padding: 0;
  }
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${cssTheme.layout.spacing.s600};
  gap: ${cssTheme.layout.spacing.s300};
`

export const MobileMenuUserSection = ({
  isAuthenticated,
  isLoading,
  onLogInClick,
  onSignUpClick,
  onClickEditAccount,
  isSignInHidden = false,
  programSlot = null,
  userTagSlot = null
}: PropsType) => {
  if (isLoading) {
    return <MobileMenuUserSectionSkeleton />
  }

  return (
    <UserSectionWrapper
      className={cx(
        isAuthenticated && '--is-authenticated',
        isSignInHidden && '--is-sign-in-hidden'
      )}
    >
      {isAuthenticated ? (
        <>
          <MobileMenuUserInfo
            onClickEditAccount={onClickEditAccount}
            tagSlot={userTagSlot}
          />
          {programSlot}
        </>
      ) : (
        !isSignInHidden && (
          <>
            <TextWrapper>
              <Text variant="titleL">
                <FormattedMessageWrapper
                  id="signInCreateAccount"
                  defaultMessage="Sign in or create account"
                />
              </Text>
              <Text variant="bodyM">
                <FormattedMessageWrapper
                  id="userWidget.memberDisclaimer"
                  defaultMessage="Find lower prices and member-only deals"
                />
              </Text>
            </TextWrapper>
            <AuthenticationButtons
              size="lg"
              onSignUpClick={onSignUpClick}
              onLogInClick={onLogInClick}
            />
          </>
        )
      )}
    </UserSectionWrapper>
  )
}
